import { Filter } from '@anytag/shared-molecules';
import { useAllInfluencersContext } from '../AllInfluencersContext';
import { BasicFilter } from './BasicFilter';

export const AllInfluencersFilter = () => {
  const { filter, setFilter, isEngagementPage, isPackagePage } = useAllInfluencersContext();

  return (
    <Filter.Provider onSubmit={setFilter} values={filter} className="rounded-none">
      <BasicFilter isEngagementPage={isEngagementPage} isPackagePage={isPackagePage} />
    </Filter.Provider>
  );
};
